const InfoRow = ({ label, value, isLink }) => (
  <div className="flex flex-col sm:flex-row sm:items-center py-3 border-b border-[#334155]/50 last:border-0">
    <span className="text-[#64748B] text-sm sm:w-40 mb-1 sm:mb-0">{label}</span>
    {isLink && value ? (
      <a 
        href={value} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="text-[#60A5FA] hover:text-[#93C5FD] transition-colors text-sm"
      >
        {value}
      </a>
    ) : (
      <span className="text-[#E2E8F0] text-sm">{value || '-'}</span>
    )}
  </div>
);

export default InfoRow;
